/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/** Unique tabs using H6 as an anchor **/
$($('.product-single__box__block').find('h6').get().reverse()).each(function(i) {
  	
  	var tabName = $(this).text();
  	tabContent = '';
  	
  	//check if h6 has text inside
 	if ($(this).text() != '') {
      	
      	//hide h6
    	$(this).hide();
  
      	//combine content between H6 elements
        $(this).nextUntil('h6').each(function() {
            tabContent = tabContent + this.outerHTML;
          	
          	//hide content
            $(this).hide();
        });
		
      	//generate tab HTML
      	//$('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-accordion-info"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
        $('.js-accordion accordion-group').prepend('<details id="#acc-unique-'+ [i] +'" ><summary><h4 class="product-single__accordion__title-text">' + tabName + '</h4><summary-icon><i class="icon icon--plus-t" aria-hidden="true"></i></summary-icon></summary><details-content><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></details-content></details>');

    } else {	

      	//hide empty H6
      	$(this).hide();
    }
});
/* Accordian Js
================================================== */
$(function() {
  $('.aff-faq-title').click(function(j) {
    
    var dropDown = $(this).closest('.aff-faq-blk').find('.aff-faq-content');
    $(this).closest('.acc').find('.aff-faq-content').not(dropDown).slideUp();
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.acc').find('.aff-faq-title.active').removeClass('active');
      $(this).addClass('active');
    }
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});
$('.lba').click(function(e){
  e.preventDefault();
  var target = $($(this).attr('href'));
  if(target.length){
    var scrollTo = target.offset().top;
    $('body, html').animate({scrollTop: scrollTo+ -120 +'px'}, 800);
  }
});


$('#sign_up').click(function(e){
  var target = $($(this).attr('href'));
  if(target.length){
    var scrollTo = target.offset().top;
    $('body, html').animate({scrollTop: scrollTo+ -100 +'px'}, 800);
  }
});

$('#sign_up2').click(function(e){
  e.preventDefault();
  var target = $($(this).attr('href'));
  if(target.length){
    var scrollTo = target.offset().top;
    $('body, html').animate({scrollTop: scrollTo+ -70 +'px'}, 800);
  }
});
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}